import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import * as firebase from 'firebase';
import { MatChipInputEvent, ErrorStateMatcher, MatDialog } from '@angular/material';
import { Subscription } from '../../../../../node_modules/rxjs/Subscription';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Http, Headers } from '@angular/http';
import { ApiService } from '../../../core/services/api.service';
import { tokenCreator } from '../../../core/services/token.service';
import { DialogComponent } from './dialog/dialog.component';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { supportsWebAnimations } from '@angular/animations/browser/src/render/web_animations/web_animations_driver';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';

@Component({
  selector: 'app-create-corporate-user',
  templateUrl: './create-corporate-user.component.html',
  styleUrls: ['./create-corporate-user.component.scss'],
})
export class CreateCorporateUserComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('f') myForm;
  myControl: FormControl = new FormControl();
  name: FormControl = new FormControl();
  rakip: FormControl = new FormControl();
  myModel = true;
  model = [
    {
      'id': 'feedback-home',
      'title': 'Anasayfa',
      'type': 'item',
      'icon': 'feedback-home.png',
      'url': '/feedback-home',
      'role': '/business/professional/proplus'
    },
    {
      'id': 'mdy',
      'title': 'Müşteri Deneyim Yönetimi',
      'type': 'collapse',
      'icon': 'list',
      'children': [

        {
          'id': 'post-reply',
          'title': 'Cevapla',
          'type': 'item',
          'icon': 'reply.png',
          'url': '/post-reply',
          'role': '/business/professional/proplus'
        },
        // {
        //     'id': 'sample',
        //     'title': 'Hashtag Kırılım Analizi',
        //     'type': 'item',
        //     'icon': 'hashtag-kirilim.png',
        //     'url': '/sample',
        //     'role': '/business/professional/proplus'
        // },

        {
          'id': 'answer-details',
          'title': 'Marka Skor Analizi',
          'type': 'item',
          'icon': 'answer-details.png',
          'url': '/answer-details',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'customer-list',
          'title': 'Müşteri Listesi',
          'type': 'item',
          'icon': 'customer-list.png',
          'url': '/customer-list',
          'role': '/professional/proplus'
        },
        {
          'id': 'answer-templates',
          'title': 'Şablonlar',
          'type': 'item',
          'icon': 'templates.png',
          'url': '/answer-templates',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'search-by-tag',
          'title': 'Etiketler',
          'type': 'item',
          'icon': 'interactions.png',
          'url': '/search-by-tag',
          'role': '/business/professional/proplus',

        },
        {
          'id': 'tags-details',
          'title': 'Etiket Analizi',
          'type': 'item',
          'icon': 'answer-details.png',
          'url': '/tags-details',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'word-details',
          'title': 'Kelime Analizi',
          'type': 'item',
          'icon': 'answer-details.png',
          'url': '/keyword-list',
          'role': '/business/professional/proplus'
        }
      ]
    },
    {
      'id': 'ry',
      'title': 'Rekabet Analizi',
      'type': 'collapse',
      'icon': 'list',
      'children': [
        {
          'id': 'brand-crosscheck-all',
          'title': 'Genel Sıralama',
          'type': 'item',
          'icon': 'rivals-brand-crosscheck.png',
          'url': '/brand-crosscheck-all',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'brand-crosscheck',
          'title': 'Sektör Sıralama',
          'type': 'item',
          'icon': 'brand-crosscheck.png',
          'url': '/brand-crosscheck',
          'role': '/professional/proplus'
        },
        {
          'id': 'rivals-crosscheck',
          'title': 'Rekabet Sıralama',
          'type': 'item',
          'icon': 'rivals-crosscheck.png',
          'url': '/rivals-crosscheck',
          'role': '/proplus'
        },
        // {
        //     'id': 'rivals-speeds-of-reply',
        //     'title': 'Cevaplama Hızı Rakipler',
        //     'type': 'item',
        //     'icon': 'rivals-speed-of-reply.png',
        //     'url': '/rivals-speeds-of-reply',
        //     'role': '/proplus'
        // },
        {
          'id': 'competetion',
          'title': 'Tıklama Oranı Analizi',
          'type': 'item',
          'icon': 'competition-analysis.png',
          'url': '/competetion',
          'role': '/proplus'
        }
      ]
    },
    {
      'id': 'mde',
      'title': 'Performans Analizi',
      'type': 'collapse',
      'icon': 'list',
      'children': [
        {
          'id': 'brand-criterias',
          'title': 'Marka Değerlendirme',
          'type': 'item',
          'icon': 'brand-crosscheck.png',
          'url': '/brand-criterias',
          'role': '/professional/proplus'
        },
        {
          'id': 'user-criterias',
          'title': 'Müşteri Segmentasyonu',
          'type': 'item',
          'icon': 'brand-crosscheck.png',
          'url': '/user-criterias',
          'role': '/proplus'
        }
      ]
    },
    {
      'id': 'me',
      'title': 'Etkileşim Analizi',
      'type': 'collapse',
      'icon': 'list',
      'children': [
        {
          'id': 'interaction-posts',
          'title': 'Etkileşimler',
          'type': 'item',
          'icon': 'interactions.png',
          'url': '/interaction-posts',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'top-ten-hashtags',
          'title': 'Hashtag Etkileşimler',
          'type': 'item',
          'icon': 'interactions.png',
          'url': '/top-ten-hashtags',
          'role': '/business/professional/proplus'
        },
        {
          'id': 'best-interactions-posts',
          'title': 'Post Etkileşimler',
          'type': 'item',
          'icon': 'interactions.png',
          'url': '/best-interactions-posts',
          'role': '/business/professional/proplus'
        }
      ]
    },
    {
      'id': 'settings',
      'title': 'Ayarlar',
      'type': 'collapse',
      'icon': 'list',
      'children': [
        {
          'id': 'account',
          'title': 'Hesap Ayarları',
          'type': 'item',
          'icon': 'settings_ikon-01.jpg',
          'url': '/profile-settings',
          'role': '/business/professional/proplus'

        },
        {
          'id': 'banner',
          'title': 'Banner Alanları',
          'type': 'item',
          'icon': 'settings_ikon-01.jpg',
          'url': '/banner-upload',
          'role': '/business/professional/proplus'
        },


      ]

    },

    {
      'id': 'support',
      'title': 'Destek',
      'type': 'item',
      'icon': 'support.png',
      'url': '/support',
      'role': '/business/professional/proplus'
    }


  ];
  // checked = false;
  // checked1 = false;
  // checked2 = false;
  indeterminate = false;
  labelPosition = 'after';
  checkVal: any;
  disabled = false;
  roleName: any;
  form: FormGroup;
  formErrors: any;
  company: any;
  showForm = true;
  roles: string;
  list = [];
  categories = environment.categoriesModel;
  sub: Subscription;
  brandList = [];
  filteredOptions: Observable<string[]>;
  filteredOptions2: Observable<string[]>;
  brands = [];

  waiter = false;
  constructor(
    private formBuilder: FormBuilder,
    private http: Http,
    private afs: AngularFirestore,
    private httpclient: HttpClient,
    private dialog: MatDialog,
    private api: ApiService
  ) {
    // const firestore = firebase.firestore();
    // const settings = { timestampsInSnapshots: true };
    // firestore.settings(settings);

    setTimeout(() => {
      this.model.filter(element => {
        if (element.hasOwnProperty('children')) {
          element["children"].filter(a => {
            this.list.push(a)
          })
        }
      })
    }, 500)
    this.formErrors = {
      category: {},
      mail: {},
      firstname: {},
      lastname: {},
      role: {},
      name: {},
      // uniqueName: {},
      password: {}
    };
  }
  onRole(event) {
    this.checkVal = [];
    this.checkVal = event.value;
  }
  onChange(event) {
    if (event.checked == true) {
      console.log(event.source.value);


      this.model.filter(a => {
        if (a.hasOwnProperty("children")) {
          a["children"].filter(b => {
            if (event.source.value == b.id) {
              b.role = this.checkVal;
            }
          })

        }
      })
    }
    else {

      this.model.filter(a => {
        if (a.hasOwnProperty('children')) {
          a["children"].filter(b => {
            if (event.source.value == b.id) {
              b.role = '';
            }
          })

        }
      })
    }


  }

  ngOnInit() {
    this.roles = localStorage.getItem('currentUserRole');

    this.filteredOptions = this.name.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filter(val))
      );
    this.filteredOptions2 = this.rakip.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filter(val))
      );

    this.form = this.formBuilder.group({
      category: ['', Validators.required],
      password: ['', Validators.required],
      mail: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      role: ['basic', Validators.required],
      name: ['', Validators.required]
      // uniqueName: ['', Validators.required]
    });
    this.form.valueChanges.subscribe((a) => {

      this.roleName = a.role;

      this.onFormValuesChanged();
    });
    this.form.get('category').valueChanges.subscribe((a) => {
      this.waiter = true;
      this.getBrand(a);
    })
  }

  filter(val: string): string[] {
    return this.brandList.filter(option =>
      option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }
  nested(data) {
    data.forEach(element => {
      return element.name
    })
  }
  getBrand(category) {
    console.log(category);

    // if (this.sub) {
    //   this.sub.unsubscribe();
    // }
    this.brandList = [];

    this.sub = this.afs.collection('brands', ref => ref.where('category', '==', category)).valueChanges().subscribe(data => {
      data.forEach(a => {
        this.brandList.push(a['name']);
      });
      this.waiter = false;



    })


  }


  onFormValuesChanged() {
    for (const field in this.formErrors) {
      if (!this.formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.formErrors[field] = {};

      // Get the control
      const control = this.form.get(field);

      if (control && control.dirty && !control.valid) {
        this.formErrors[field] = control.errors;
      }
    }
  }

  changeText(string) {
    return string
      .trim()
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/\./g, '')
      .replace(/\-/g, '')
      .replace(/\'/g, '')
      .replace(/\s/g, '')
      .toLowerCase();
  }


  send() {

    let mail = this.form.get('mail').value; // to get value in input tag
    let password = this.form.get('password').value; // to get value in input tag
    let uniqueName = this.changeText(this.name.value);
    let firstname = this.form.get('firstname').value;
    let lastname = this.form.get('lastname').value;
    let category = this.form.get('category').value;
    var date = new Date();
    let name = this.name.value;
    let role = this.form.get('role').value;
    console.log(uniqueName);
    console.log(date);


    let createAuth = firebase.auth().createUserWithEmailAndPassword(mail, password);
    let createUser = createAuth.then(data => {
      console.log(data.uid)
      this.afs.collection('corporateUsers').doc(data.uid).set({
        firstname: firstname,
        lastname: lastname,
        companies: [
          {
            category: category,
            name: name,
            uniqueName: uniqueName,
            role: role,
            rivalBrand: this.brands
          }
        ],
        list: this.model,
        membershipDate: this.dateFormat(date),
        isEmailVerified: false
      });

      this.api.sqlPost('corporate/insertCorporateMember', {
        uniqueName: uniqueName,
        membershipDate: this.dateFormat(date)
      }).map(res => res.json()).subscribe(d => {
        console.log(d);
        console.log(uniqueName);
      })
      return data.uid;
    }).then((uid) => {
      this.SendVerificationMail({ email: mail, nameto: `${firstname} ${lastname}`, uid: uid, password: password });

      this.showForm = false;
      setTimeout(() => {
        // this.form.reset()
        this.showForm = true;
        // this.name.reset();
        // this.brands = [];
        this.waiter = false;
      });
      let dialogRef2 = this.dialog.open(DialogComponent, {
        panelClass: 'my-class',
        width: '500px',
        data: {
          message: "Kayıt oluştu.E posta ve şifrenizle giriş yapabilirsiniz."
        }
      });
    });
  }

  SendVerificationMail(userinfo: Object) {
    const token = tokenCreator();
    const option = {
      data: {
        customToken: token,
        email: userinfo['email'],
        nameTo: userinfo['nameto'],
        nameFrom: 'bigadvice-Analytics'
      }
    }
    console.log(userinfo);
    console.log(token, 'token');
    this.request(option);

  }
  request(option) {

    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendEmailVerificationCorporate', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }



  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  addSelect(event) {
    let value = event.option.value;
    if (value) {
      console.log(value);

      this.brands.push({ name: value, uniqueName: this.changeText(value) });
      console.log("brands");
      console.log(this.brands);


    }
    this.input.nativeElement.value = null;
  }
  addCategory(event: MatChipInputEvent): void {
    this.brands = [];
    const input = event.input;
    const value = event.value;

    // Add category
    if (value) {
      console.log("value");
      console.log(value);

      this.brands.push({ name: value, uniqueName: this.changeText(value) });
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeCategory(category) {
    const index = this.brands.indexOf(category);

    if (index >= 0) {
      this.brands.splice(index, 1);
    }
  }
  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  includeString(role, value) {
    if (role.includes(value)) {
      return role;

    }

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-corporate-user/create-corporate-user.component.ts